import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  UploadCounter: 0,
  SpeedDialValue: 0,
  Certificat_Counter: 0,
  Courrier_Counter: 0,
  ExamenCompl_Counter: 0,
  Lunettes_Counter: 0,
  Medicaments_Counter: 0,
};

export const CountersSlice = createSlice({
  name: "Counters",
  initialState,
  reducers: {
    UploadCounter: (state, action) => {
      state.UploadCounter = action.payload;
    },
    Certificat_Counter_Reducer: (state, action) => {
      state.Certificat_Counter = action.payload;
    },
    Medicaments_Counter_Reducer: (state, action) => {
      state.Medicaments_Counter = action.payload;
    },
    Courrier_Counter_Reducer: (state, action) => {
      state.Courrier_Counter = action.payload;
    },
    ExamenCompl_Counter_Reducer: (state, action) => {
      state.ExamenCompl_Counter = action.payload;
    },
    Lunettes_Counter_Reducer: (state, action) => {
      state.Lunettes_Counter = action.payload;
    },
    UpdateSpeedDialValue: (state, action) => {
      state.SpeedDialValue = action.payload;
    },
  },
});

export const {
  UploadCounter,
  UpdateSpeedDialValue,
  Certificat_Counter_Reducer,
  Medicaments_Counter_Reducer,
  Courrier_Counter_Reducer,
  ExamenCompl_Counter_Reducer,
  Lunettes_Counter_Reducer
} = CountersSlice.actions;

export const selectCounters = (state) => state.Counters;

export default CountersSlice.reducer;
